import React, { useState } from "react";
import emailjs from "emailjs-com";
import waarborgenContact from "../assets/waarborgen2.jpg";
import {
  BuildingOffice2Icon,
  EnvelopeIcon,
  ShieldCheckIcon,
} from "@heroicons/react/24/outline";

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    message: "",
  });

  const [isSent, setIsSent] = useState(false);
  const [error, setError] = useState("");

  const waarborgen = [
    { name: "Burgerlijke aansprakelijkheid", icon: ShieldCheckIcon },
    { name: "Bescherming en verlies", icon: ShieldCheckIcon },
    { name: "Lichtingskosten, hulp en berging", icon: ShieldCheckIcon },
    { name: "Rechtsbijstand", icon: ShieldCheckIcon },
    { name: "Persoonlijke ongevallen", icon: ShieldCheckIcon },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (
      !formData.firstName ||
      !formData.lastName ||
      !formData.email ||
      !formData.phoneNumber ||
      !formData.message
    ) {
      setError("Vul alle verplichte velden in.");
      return;
    }

    emailjs
      .send(
        "service_o5939qw", // Vervang met jouw EmailJS Service ID
        "template_d1ptgnc", // Vervang met jouw EmailJS Template ID
        formData,
        "Mq0NNULbOl3aTvHgz" // Vervang met jouw EmailJS User ID
      )
      .then(
        () => {
          setIsSent(true);
        },
        (err) => {
          setError("Er ging iets mis. Probeer het later opnieuw.");
          console.error(err);
        }
      );
  };

  return (
    <div>
      <section className="py-10 sm:py-12">
        <div className="relative isolate mt-6">
          <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2">
            {/* Left Column with Contact Information */}
            <div className="relative flex flex-col justify-between px-6 pb-10 pt-16 sm:pt-20 lg:static lg:px-8 lg:py-48">
              <div>
                <h2 className="text-4xl font-semibold tracking-tight text-[#1a2a6c] sm:text-6xl">
                  Contacteer <span className="text-[#ff6f61]">ons</span>
                </h2>
                <p className="mt-6 text-lg leading-8 text-gray-600">
                  Mail, bel of vul het formulier in zodat ons team jouw vragen
                  kan beantwoorden. We zijn er voor je.
                </p>
                <hr className="my-4 border-[#ff6f61] border-2 sm:mx-auto lg:my-4" />
              </div>
              <div className="mt-6 space-y-4 text-base leading-7 text-gray-600 hidden lg:block">
                <div className="space-y-4 text-base leading-7 text-gray-600">
                  <div className="flex gap-x-4">
                    <BuildingOffice2Icon className="h-7 w-6 text-gray-400" />
                    <dd>
                      Mouterijstraat 60, <br />
                      3582 Koersel (Enkel op afspraak)
                    </dd>
                  </div>
                  <div className="flex gap-x-4">
                    <EnvelopeIcon className="h-7 w-6 text-gray-400" />
                    <dd>
                      <a
                        href="mailto:info@boot-verzekering.be"
                        className="hover:text-gray-900"
                      >
                        info@boot-verzekering.be
                      </a>
                    </dd>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <form
              onSubmit={handleSubmit}
              className="relative mx-5 max-w-[95%] sm:max-w-2xl md:max-w-3xl lg:max-w-4xl px-4 py-8 sm:px-6 sm:py-10 md:px-12 md:py-12 lg:p-12 rounded-3xl bg-[#1a2a6c]"
            >
              <div className="mx-auto max-w-xl">
                <h3 className="text-[#ff6f61] text-4xl font-extrabold text-left">
                  Hulp nodig?
                </h3>
                <p className="text-[#efebe2] mt-1 text-xl font-bold text-left">
                  We zijn er voor je.
                </p>

                {isSent ? (
                  <p className="mt-6 text-lg text-[#ff6f61]">
                    Bedankt! Je bericht is verzonden. Er is ook een
                    bevestigingsmail naar je e-mailadres verstuurd.
                  </p>
                ) : (
                  <div>
                    <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2 mt-6">
                      <div>
                        <label
                          htmlFor="firstName"
                          className="block text-sm font-semibold leading-6 text-[#efebe2]"
                        >
                          Voornaam
                        </label>
                        <input
                          id="firstName"
                          name="firstName"
                          type="text"
                          value={formData.firstName}
                          onChange={handleChange}
                          placeholder="Jan"
                          className="mt-2.5 block w-full rounded-md border-2 border-[#ff6f61] px-3.5 py-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#ff6f61]"
                        />
                      </div>

                      <div>
                        <label
                          htmlFor="lastName"
                          className="block text-sm font-semibold leading-6 text-[#efebe2]"
                        >
                          Achternaam
                        </label>
                        <input
                          id="lastName"
                          name="lastName"
                          type="text"
                          value={formData.lastName}
                          onChange={handleChange}
                          placeholder="Jansen"
                          className="mt-2.5 block w-full rounded-md border-2 border-[#ff6f61] px-3.5 py-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#ff6f61]"
                        />
                      </div>

                      <div className="sm:col-span-2">
                        <label
                          htmlFor="email"
                          className="block text-sm font-semibold leading-6 text-[#efebe2]"
                        >
                          Emailadres
                        </label>
                        <input
                          id="email"
                          name="email"
                          type="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="jan.jansen@example.com"
                          className="mt-2.5 block w-full rounded-md border-2 border-[#ff6f61] px-3.5 py-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#ff6f61]"
                        />
                      </div>

                      <div className="sm:col-span-2">
                        <label
                          htmlFor="phoneNumber"
                          className="block text-sm font-semibold leading-6 text-[#efebe2]"
                        >
                          Telefoonnummer
                        </label>
                        <input
                          id="phoneNumber"
                          name="phoneNumber"
                          type="tel"
                          value={formData.phoneNumber}
                          onChange={handleChange}
                          placeholder="+32 476 01 81 32"
                          className="mt-2.5 block w-full rounded-md border-2 border-[#ff6f61] px-3.5 py-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#ff6f61]"
                        />
                      </div>

                      <div className="sm:col-span-2">
                        <label
                          htmlFor="message"
                          className="block text-sm font-semibold leading-6 text-[#efebe2]"
                        >
                          Vertel ons hoe we je kunnen helpen
                        </label>
                        <textarea
                          id="message"
                          name="message"
                          rows={4}
                          value={formData.message}
                          onChange={handleChange}
                          placeholder="Uw bericht..."
                          className="mt-2.5 block w-full rounded-md border-2 border-[#ff6f61] px-3.5 py-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#ff6f61]"
                        />
                      </div>
                    </div>

                    {error && (
                      <p className="mt-4 text-sm text-[#ff6f61]">{error}</p>
                    )}

                    <div className="mt-6 flex justify-start">
                      <button
                        type="submit"
                        className="rounded-md bg-[#ff6f61] px-4 py-2 text-center text-sm font-semibold text-[#efebe2] shadow-md hover:bg-[#ff8b7c]"
                      >
                        Verzend
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </form>

            <div className="mt-10 px-6 lg:hidden">
              <div className="space-y-4 text-base leading-7 text-gray-600">
                <div className="flex gap-x-4">
                  <BuildingOffice2Icon className="h-7 w-6 text-gray-400" />
                  <dd>
                    Mouterijstraat 60, <br />
                    3582 Koersel (Enkel op afspraak)
                  </dd>
                </div>
                <div className="flex gap-x-4">
                  <EnvelopeIcon className="h-7 w-6 text-gray-400" />
                  <dd>
                    <a
                      href="mailto:info@boot-verzekering.be"
                      className="hover:text-gray-900"
                    >
                      info@boot-verzekering.be
                    </a>
                  </dd>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
